import { AppTheme } from "./theme-interface";

const DefaultAppTheme: AppTheme = {
  name: 'Default',
  schema: {
    logoUrl: '',
    logoHeight: '25px',
    siteName: 'Basecamp',
    shortSiteName: 'Basecamp',
    backgroundImgUrl: 'url(assets/bg_home.jpg)',
    bodyBackgroundColor: "#f4f3f2",
    faviconUrl: "",

    fontPrimary: 'Inter',
    fontSecondary: 'Inter',

    cardBodyColor: '#ffffff',
    cardBorderRadius: "16px",

    successColor: '#ACFFC1',
    dangerColor: '#ffc2c2',
    warningColor: '#F2994A',
    mutedColor: '#DCD9D9',

    headlineColor: '#000000', //Empty Use default color
    headlineFont: '', //Empty use default font

    primaryColor: '#FFF000',
    primaryDarkColor: '',
    secondaryColor: '#1F1E1E',

    headerBackgroundColor: '#ffffff',
    headerTextColor: '#000000', //Empty use default
    headerHeight: "80px",
    headerTextSize: "14px",

    footerBackgroundColor: '#1e1e1e', //empty use secondary color
    footerTextColor: '#ffffff', //empty use tertiary color

    sideMenuBackgroundColor: '#f2f4f2',
    sideMenuTextColor: '', //default text


    buttonPrimaryTextColor: '#000000',
    buttonPrimaryHoverColor: '#FFFF99', //empty use primary dark
    buttonSecondaryTextColor: '#ffffff', //empty use tertiary color
    buttonDisabledColor: '',
    buttonRadius: '24px',


    textDefaultColor: '#000000',
    textDefaultMediumColor: '#383839',
    textDefaultLightColor: '#626262',
    textPrimaryColor: '#fff000',
    textSecondaryColor: '#000',
    textTertiaryColor: '#ffffff',

    borderColor: "#DCD9D9",
    borderActiveColor: "#000000",
    borderRadius: '8px',

    formLabelColor: '#626262',
    formPlaceHolderColor: '#939393',
    formBorderRadius: "8px",
    formBorderWidth: "1px",
    formControlBackgroundColor: "#ffffff",
    formInputColor: "#000000",

    tableHeaderColor: '',
  }
}

export default DefaultAppTheme;